<template>
  <b-modal
    id="modal-add-transfer-form"
    title="Thêm mới phiếu chuyển cửa hàng"
    hide-footer
    backdrop
    no-close-on-backdrop
  >
    <v-form lazy-validation>
      <div v-if="checkJobTitleById">
        <div class="w-100 mb-5" v-if="!isMyForms">
          <label>Họ tên, mã NV: <span class="text-danger">*</span></label>
          <EmployeeSearch
            v-model="searchEmployee"
            :employee-id="mainModel.employeeId"
            placeholder="tên hoặc mã nhân viên"
            @employee-selected="onEmployeeSelected"
          />
          <div class="w-100 mt-5">
            <label>Cửa hàng hiện tại: <span class="text-danger">*</span></label>
            <b-input
              :value="currentStoreName"
              type="text"
              size="sm"
              single-line
              hide-details
              disabled
            />
          </div>
        </div>
        <div class="w-100 mb-5" v-else>
          <label>Họ tên, mã NV: <span class="text-danger">*</span></label>
          <b-input
            :value="currentEmployeeFullName"
            type="text"
            size="sm"
            single-line
            hide-details
            disabled
          />
        </div>
      </div>

      <div v-else>
        <div class="w-100 mb-5">
          <label>Họ tên, mã NV: <span class="text-danger">*</span></label>
          <b-input
            v-model="currentEmployeeFullName"
            type="text"
            size="sm"
            single-line
            hide-details
            disabled
          />
        </div>
        <div class="w-100 mb-5">
          <label>Cửa hàng hiện tại: <span class="text-danger">*</span></label>
          <b-input
            v-model="currentEmployeeStoreName"
            type="text"
            size="sm"
            single-line
            hide-details
            disabled
          />
        </div>
      </div>

      <div class="w-100 mb-5">
        <label
          >Cửa hàng muốn chuyển đến: <span class="text-danger">*</span></label
        >
        <Autosuggest
          :model="searchTargetStore"
          :suggestions="filteredOptions"
          @select="onSelectedTargetStore"
          @change="onInputChangeTargetStore"
          placeholder="tên cửa hàng muốn chuyển đến"
          suggestionName="suggestionName"
        />
      </div>
      <div class="w-100 mb-5">
        <label>Ghi chú:</label>
        <b-form-textarea
          v-model="mainModel.description"
          id="textarea"
          size="sm"
          placeholder="Lý do chuyển cửa hàng"
          rows="3"
          max-rows="6"
        ></b-form-textarea>
      </div>

      <b-button
        size="sm"
        variant="primary"
        class="mr-3"
        style="width: 100px"
        @click="createTransferForm"
        >Tạo phiếu
      </b-button>

      <b-button
        size="sm"
        variant="secondary"
        class="mr-3"
        style="width: 100px"
        @click="hideModalAddForm"
        >Hủy
      </b-button>
    </v-form>
  </b-modal>
</template>

<script>
import Autosuggest from '@/view/base/auto-sugguest/AutoSuggest.vue';
import EmployeeSearch from '@/view/components/common/EmployeeSearch.vue';
import ApiService from '@/core/services/api.service';
import { makeToastSuccess, makeToastFaile, handleError } from '@/utils/common';
import { JOB_TITLE } from '@/utils/enum';

export default {
  components: { Autosuggest, EmployeeSearch },
  props: {
    userInfo: {
      type: Object,
    },
    listStores: {
      type: Array,
    },
    isMyForms: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      mainModel: {
        employeeId: null,
        currentStoreId: null,
        targetStoreId: null,
        description: '',
      },
      optionsForSearch: [],
      filteredOptions: [],
      options: [],
      searchEmployee: '',
      searchTargetStore: null,
      currentEmployeeFullName: null,
      currentEmployeeStoreName: null,
      currentStoreName: null,
    };
  },
  watch: {
    listStores(newValue) {
      this.options = newValue;
      if (!this.checkJobTitleById) {
        this.options = this.filterOptionsListStore(this.userInfo.listStoreId);
      }

      const currentStore = this.listStores.find(
        (item) => item.id === this.userInfo.storeId,
      );
      if (currentStore?.name) {
        this.currentStoreName = currentStore.name;
        this.currentEmployeeStoreName = currentStore.name;
      }
      this.filteredOptions = [...this.options];
      this.optionsForSearch = [...this.options];
    },
  },
  mounted() {
    this.initAddTransferFormModal();
  },
  computed: {
    checkJobTitleById() {
      const jobTitleIds = [JOB_TITLE.GD, JOB_TITLE.QL, JOB_TITLE.HTQL];
      const { jobTitleId } = this.userInfo;
      return jobTitleIds.includes(jobTitleId);
    },
  },
  methods: {
    initializeEmployeeFromUserInfo() {
      const { id, fullName, storeId, storeName } = this.userInfo;

      if (id) {
        this.mainModel.employeeId = id;
      }

      if (fullName) {
        this.currentEmployeeFullName = fullName;
        this.searchEmployee = fullName;
      }

      if (storeId) {
        this.mainModel.currentStoreId = storeId;
        this.currentEmployeeStoreName = storeName;
      }
    },
    validateForm() {
      if (!this.mainModel.employeeId) {
        makeToastFaile('Vui lòng chọn nhân viên');
        return false;
      }

      if (!this.mainModel.targetStoreId) {
        makeToastFaile('Vui lòng chọn cửa hàng muốn chuyển đến');
        return false;
      }

      return true;
    },
    createTransferForm: async function () {
      if (!this.validateForm()) {
        return;
      }

      try {
        const data = {
          ...this.mainModel,
        };
        const res = await ApiService.post('v1/transfer-store-forms', data);
        makeToastSuccess(res.data.data.message);
        this.hideModalAddForm();
        this.$emit('fetchTransferStoreForms');
      } catch (error) {
        handleError(error);
      }
    },
    onInputChangeTargetStore(text) {
      if (!text) {
        text = '';
      }
      this.searchTargetStore = text;
      const filteredData = this.filteredOptions.filter((item) => {
        return (
          item.name.toLowerCase().indexOf(text.toLowerCase()) > -1 ||
          item.shortName.toLowerCase().indexOf(text.toLowerCase()) > -1
        );
      });
      this.filteredOptions = [...filteredData];
      if (this.searchTargetStore == '') {
        this.filteredOptions = this.optionsForSearch;
        this.mainModel.targetStoreId = null;
      }
      if (!this.searchTargetStore) {
        this.mainModel.targetStoreId = null;
      }
    },
    onEmployeeSelected(employee) {
      if (!employee) {
        this.mainModel.employeeId = null;
        this.mainModel.currentStoreId = null;
        this.currentEmployeeStoreName = null;
        this.currentStoreName = null;
        this.filteredOptions = [...this.options];
        this.optionsForSearch = [...this.options];
        return;
      }

      this.mainModel.employeeId = employee.id;

      if (employee.storeName) {
        this.currentStoreName = employee.storeName;
        this.currentEmployeeStoreName = employee.storeName;
      }

      if (employee.storeId) {
        this.mainModel.currentStoreId = employee.storeId;
      }
    },
    filterOptionsListStore() {
      return this.options;
      // const listStore = this.options.filter((item) => {
      //   return !listStoreId.includes(item.id);
      // });
      // return listStore;
    },
    onSelectedTargetStore(option) {
      this.mainModel.targetStoreId = option.item.id;
      this.searchTargetStore = option.item.name;
    },
    hideModalAddForm() {
      this.$bvModal.hide('modal-add-transfer-form');
      this.searchEmployee = '';
      this.searchTargetStore = null;
      this.resetMainModel();
    },
    showModal() {
      this.initAddTransferFormModal();
      this.$bvModal.show('modal-add-transfer-form');
    },
    initAddTransferFormModal() {
      if (this.isMyForms) {
        this.initializeEmployeeFromUserInfo();
      } else {
        const { fullName, id, storeName } = this.userInfo;
        if (fullName) this.currentEmployeeFullName = fullName;
        if (id) {
          this.mainModel.employeeId = id;
        }
        if (storeName) {
          this.currentEmployeeStoreName = storeName;
        }
      }
    },
    resetMainModel() {
      this.mainModel = {
        employeeId: null,
        currentStoreId: null,
        targetStoreId: null,
        description: '',
      };
      this.currentStoreName = null;
      this.currentEmployeeStoreName = null;
    },
  },
};
</script>

<style scoped>
::v-deep .modal-backdrop {
  opacity: 0.5 !important;
  background-color: #000 !important;
}
</style>
